<template>
  <deposit-balance
    :color="color"
    :controls="controls"
    :editable="editable"
    :contract="contract"
    @grabstart="(e) => $emit('grabstart', e)"
    @grabend="(e) => $emit('grabend', e)"
    v-if="ShowSettlements"
  ></deposit-balance>
  <bills-stat
    :color="color"
    :controls="controls"
    :editable="editable"
    :contract="contract"
    @grabstart="(e) => $emit('grabstart', e)"
    @grabend="(e) => $emit('grabend', e)"
    v-else></bills-stat>
</template>

<script>
import DepositBalance from './DepositBalance'
import BillsStat from './BillsStat'

import { ShowSettlements } from '@/mixins/displayRules'

export default {
  mixins: [ShowSettlements],

  props: {
    color: {
      type: String,
      default: 'dark'
    },

    controls: {
      type: Boolean,
      default: false
    },

    editable: {
      type: Boolean,
      default: false
    },

    contract: {
      type: Number,
      default: null
    }
  },

  components: {
    DepositBalance,
    BillsStat
  }
}
</script>
